import _ from 'lodash';
import {Component, Module} from 'app/decorators';
import ProductStore from 'app/stores/product';
import tpl from './delivery.picker.html';


const pl5_customer = [
    'apply_haul_itemized',
    'haul_itemized',
];


@Module({
    name: "app.directives.delivery.picker",
    modules: [
        ProductStore,
    ]
})
@Component({
    selector: 'blnd-delivery-picker',
    bindings: {
        ngModel: '=',
        ngDisabled: '=',
        mode: '@?',
        ngChange: '&?',
        data: '=?'
    },
    template: tpl,
})
export default class C {
    constructor ($scope, $element, Config, ProductStore) {
        "ngInject";
        this.scope = $scope;
        this.$element = $element;
        this.mode = this.mode || 'view';

        this.productStore = ProductStore;
        this.config = Config;

        this.watcher = null;

        if (_.isUndefined(this.data)) {
            this.delivery = this.config.$config.delivery;
        } else {
            let is5PL = this.data.customer && this.data.customer.price_level === 5;
            this.delivery = _.filter(this.config.$config.delivery, function (obj) {
                let exists = pl5_customer.indexOf(obj[0]);
                return obj[0] == 'pickup' || is5PL && exists >= 0 || !is5PL && exists === -1;
            });
        }

        this.deliveryMap = _.fromPairs(this.delivery);
    }

    getName () {
        let self = this;
        return self.deliveryMap[self.ngModel];
    }

    $onInit () {
        let self = this;
        this.watcher = this.scope.$watch(() => self.ngModel, function (newValue, oldValue) {
            if (newValue === oldValue) { return; }
            if (!_.isUndefined(self.data)) {
                self.onDeliveryChange();
            }

            self.onChange();
        }, true);
    }

    $onDestroy () {
        if (this.watcher) {
            this.watcher();
            this.watcher = null;
        }
        this.productStore = null;
        this.$element.remove();
        this.$element = null;
    }

    onChange () {
        if (this.ngChange) {
            this.ngChange();
        }
    }

    onDeliveryChange () {
        let self = this;
        let isExists = self.isAlreadyAdded();
        let isDeliveryItemized = self.ngModel === 'apply_haul_itemized' || self.ngModel === 'haul_itemized';
        let shouldAddProduct = (
            self.data.customer.price_level === 5 &&
            isDeliveryItemized &&
            !isExists
        );

        if (shouldAddProduct) {
            let params = {
                extra_field: 'prices',
                company: self.data.company.id,
                price_level: self.data.customer.price_level,
                customer: self.data.customer.id,
            };
            self.productStore.get(self.config.$config.application_product_id, params).then(function (response) {
                self.data.products.push({
                    product: response,
                    rate_acre: 1,
                    quantity: self.data.acres,
                });
            });
        } else if (isExists && !isDeliveryItemized) {
            let idx = _.findIndex(self.data.products, (o) => {
                return o.product && o.product.id === self.config.$config.application_product_id;
            });
            self.data.products.splice(idx, 1);
        }
    }

    get applicationProduct () {
        let self = this;
        return _.filter(self.data.products, (o) => {
            return o.product && o.product.id === self.config.$config.application_product_id
        });
    }

    isAlreadyAdded () {
        return this.applicationProduct.length > 0;
    }
}



// WEBPACK FOOTER //
// ./src/app/directives/delivery.picker.js